import { Component, computed, input } from '@angular/core';

// Marcado no login para perfis sem dashboard; o layout consome e exibe o loader temporizado.
export const BRAND_LOADER_SESSION_KEY = 'nordsol.brandLoader';

// Tela de carregamento com a marca Nordsol: o logo "amanhece" de baixo para cima
// conforme o progresso (0 a 100) informado por quem a usa.
@Component({
    selector: 'app-brand-loader',
    standalone: true,
    templateUrl: './brand-loader.component.html',
    styleUrls: ['./brand-loader.component.scss'],
})
export class BrandLoaderComponent {
    progress = input(0);
    status = input('');
    label = input('Carregando');
    leaving = input(false);

    value = computed(() => Math.min(100, Math.max(0, Math.floor(this.progress()))));
    // Leitores de tela recebem o valor em passos de 10, não a cada quadro da animação.
    ariaValue = computed(() => Math.floor(this.value() / 10) * 10);
}
